import React, { createContext, useContext, useEffect, useRef } from 'react';
import { useStudioLine } from '../hooks/useStudioLine';
import { useAudio } from './AudioContext';
import { isApiConfigured } from '../api/client';

/**
 * خط الاستديو، مشتركاً بين كل من يحتاجه.
 *
 * كان كل مكوّن يفتح اتصاله الخاص بالخادم: ثلاثة مقابس لغرفة واحدة، وثلاث
 * نسخ من الحالة قد تتعارض. الاتصال واحد هنا، والجميع يقرأ منه.
 *
 * وهنا أيضاً يُقطع البث عند الاتصال: من يتكلم مع المذيع لا يصحّ أن تصدح
 * الإذاعة في أذنه — ولا أن يسمعها المذيع راجعةً من ميكروفونه.
 */

const StudioLineContext = createContext(null);

export const StudioLineProvider = ({ children }) => {
  const { currentUser, canAnswerCalls, isPlaying, pauseAudio, togglePlay } = useAudio();

  const enabled = Boolean(currentUser) && isApiConfigured();
  const line = useStudioLine(enabled);

  const myCall = line.myCall;
  // «المسؤول» هنا تعني من يردّ على المكالمات — مسؤولاً كان أو مذيعاً.
  // والخادم يتحقّق من الصلاحية مستقلاً، فهذا للعرض لا للحماية.
  const isAdmin = canAnswerCalls;

  // المكالمة التي تخصّني: مكالمتي إن كنت مستمعاً، والجارية إن كنت المسؤول
  const call = isAdmin ? line.active : myCall;
  const onCall = Boolean(call && (call.state === 'waiting' || call.state === 'active'));

  // قطع البث عند بدء المكالمة لضمان الهدوء
  useEffect(() => {
    if (onCall && isPlaying) {
      pauseAudio();
    }
  }, [onCall, isPlaying, pauseAudio]);

  return (
    <StudioLineContext.Provider value={{ ...line, isAdmin, call, onCall }}>
      {children}
    </StudioLineContext.Provider>
  );
};

export const useStudioLineContext = () => {
  const ctx = useContext(StudioLineContext);
  if (!ctx) throw new Error('useStudioLineContext خارج StudioLineProvider');
  return ctx;
};
